import { useCallback } from 'react';

type RefType = HTMLElement | null;

export function useScroll(alignment?: ScrollLogicalPosition): (ref: RefType) => void {
    return useCallback((current) => {
        current?.scrollIntoView({
            behavior: 'smooth',
            block: alignment || 'center',
        });
    }, [alignment]);
}
